import axios from 'axios';

/**
 * Instance Axios centralisée pour communiquer avec le Backend Spring Boot
 */
const api = axios.create({
  baseURL: 'https://www.s2i.com.tn/api', 
  headers: {
    'Content-Type': 'application/json',
  },
});

// ==========================================
// INTERCEPTEUR DE REQUÊTE
// Sert à injecter le Token JWT avant que la requête ne parte
// ==========================================
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ==========================================
// INTERCEPTEUR DE RÉPONSE
// Sert à gérer les erreurs globales (ex: Token expiré)
// ==========================================
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si le serveur répond 401 (Non autorisé) ou 403 (Interdit)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.warn("Session expirée ou accès refusé. Redirection...");
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      // Optionnel : rediriger vers /login si on n'y est pas déjà
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;